const Users = {
    getAllList: () => 'get/all/Users',
    getDetailById: (id) => `userProfile/${id}`,
    getBusinessById: (id) => `businessDetails/${id}`,
    updateDetailById: (id) => `updateProfile/${id}`,
    getUserAuth: (id) =>`login/merchantByAdmin/${id}`
}
export default Users
